// register the plugin on vue
import Vue from 'vue';
import axios from 'axios';
import router from '../router'
import { isExpired, logOut } from './auth'
import Store from '@/store/index.js'

Vue.prototype.$axios = axios

// APIのエンドポイントを設定（docker-compose.ymlに記載）
Vue.prototype.$axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

// ログイン永続化
if (sessionStorage.getItem('ENGetThrough')) {
  const strageData = JSON.parse(sessionStorage.getItem('ENGetThrough'));
  // sessionStrageにデータがあったらヘッダーに値を設定する
  if (strageData.user.accessToken) {
      Vue.prototype.$axios.defaults.headers.common['access-token'] = strageData.user.accessToken;
      Vue.prototype.$axios.defaults.headers.common['client']       = strageData.user.client;
      Vue.prototype.$axios.defaults.headers.common['uid']          = strageData.user.uid;
  }
}

Vue.prototype.$axios.interceptors.request.use(
	(request) => {
    // request時に一定時間操作がなかったら
    if (isExpired()) {
      request.url = '/api/v1/auth/sign_out'
      request.method = 'delete'
      request.data = undefined
      const signInPath = Store.getters['user/signInPath']
      logOut()
      if (!['AdminSignIn', 'SignIn'].includes(router.history.current.name)) {
        router.push(signInPath)
      }
      Vue.toasted.global.error({ message: '一定時間操作がありませんでした。お手数ですが、再度ログインの上ご利用をお願いします。' })
    }

    return request
  }
)

Vue.prototype.$axios.interceptors.response.use(
	(response) => {
    if (response.config?.url === '/api/v1/auth/sign_out') throw "signOut"
		return response
	},
	(error) => {
    // 認証が切れた時の処理（ログイン失敗）
		if (error.response.status == 401) {
      // 多重ログインに引っかかってないかチェック
      if (!['/api/v1/auth/validate_token', '/api/v1/auth/sign_in'].includes(error.response.config.url)) {
        Vue.prototype.$axios('/api/v1/auth/validate_token')
        return Promise.reject(error)
      }
      Vue.toasted.global.error({ message: error.response.data.errors })
      if (!['AdminSignIn', 'SignIn'].includes(router.history.current.name)) {
        router.push('/sign_in')
      }
      return Promise.reject(error)
    }

    // バリデーション失敗時の処理
		else if (error.response.status == 422) {
      Vue.toasted.global.error({ message: error.response.data.messages })
      return Promise.reject(error)
    }

    else {
      return Promise.reject(error)
    }
	}
)
